import { atom } from 'recoil';

export const header = atom({
    key: 'header',
    default: [],
});

